import { render } from "./tabAudios.vue?vue&type=template&id=9f2e9c8a&scoped=true"
import script from "./tabAudios.vue?vue&type=script&lang=js"
export * from "./tabAudios.vue?vue&type=script&lang=js"

import "./tabAudios.vue?vue&type=style&index=0&id=9f2e9c8a&scoped=true&lang=css"

import exportComponent from "/Users/mwint/Documents/Github/app-vybroo-net/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9f2e9c8a"]])

export default __exports__